module.exports = __webpack_public_path__ + "img/metro.c4bf3504.gif";